._section_1dmgk_1 .ant-collapse-content-box {
  padding-top: 0 !important;
}